import { useToast } from '@chakra-ui/react';
import axios, { CreateAxiosDefaults } from 'axios';
import { JSX } from 'react';

import { useKeycloak } from '@cccom/auth/keycloak';
import { useEnvironment } from '@cccom/config/env';

import CCAxiosContext from './context';
import {
  addAuthInterceptor,
  addSiteInterceptor,
} from './interceptors/request.interceptors';
import { addResponseInterceptor } from './interceptors/response.interceptors';

type CCAxiosProviderProps = {
  children: JSX.Element;
  isWrappingTest?: boolean;
};

export function CCAxiosProvider({
  children,
  isWrappingTest = false,
}: CCAxiosProviderProps) {
  const { BACKEND_ENDPOINT, APP } = useEnvironment();
  const { keycloak, acr } = useKeycloak();
  const toast = useToast();

  const config: CreateAxiosDefaults = {
    baseURL: BACKEND_ENDPOINT,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-APP': APP?.id,
    },
    paramsSerializer: {
      indexes: null,
    },
  };

  const axiosInstance = axios.create(config);

  /*
    When run by jest as part of a test these interceptors that depend on keycloak
    cause the test to fail. We skip them here if the provider is used in a test.
  */
  if (!isWrappingTest) {
    addAuthInterceptor({ axiosInstance, keycloak });
    addSiteInterceptor({ axiosInstance });
  }

  addResponseInterceptor({ axiosInstance, keycloak, acr, toast });

  return (
    <CCAxiosContext.Provider value={axiosInstance}>
      {children}
    </CCAxiosContext.Provider>
  );
}
